<template>
  <main class="h-auto container mx-auto px-4 main">
    <div class="flex flex-wrap items-end py-6 sm:py-16">
      <div class="w-full sm:w-2/3">
        <h1 class="font-bold mb-4 text-2xl">
          <span v-html="pageData.title"></span>
        </h1>
        <p class="w-full sm:w-3/4">
          <span v-html="pageData.default_content"></span>
        </p>
      </div>
      <div class="w-full sm:w-1/3 text-right mt-8 sm:mt-0">
        <a :href="globalValues.social_links.linkedin" target="_blank">
          <i class="fab fa-linkedin text-3xl mr-4 cursor-pointer"></i>
        </a>
        <a :href="globalValues.social_links.facebook" target="_blank">
          <i class="fab fa-facebook-square text-3xl mr-4 cursor-pointer"></i>
        </a>
        <a :href="globalValues.social_links.instagram" target="_blank">
          <i class="fab fa-instagram-square text-3xl cursor-pointer"></i>
        </a>
      </div>
    </div>
    <div class="blog">
      <div v-for="row in blogRows">
        <first-blog-row :data="row.data" v-if="row.number === 1" />
        <second-blog-row  :data="row.data" v-if="row.number === 2" />
        <third-blog-row :data="row.data" v-if="row.number === 3" />
        <fourth-blog-row :data="row.data" v-if="row.number === 4" />
        <fifth-blog-row :data="row.data" v-if="row.number === 5" />
      </div>
    </div>
  </main>
</template>

<script>
import firstBlogRow from '@/components/blog/firstBlogRow'
import secondBlogRow from '@/components/blog/secondBlogRow'
import thirdBlogRow from '@/components/blog/thirdBlogRow'
import fourthBlogRow from '@/components/blog/fourthBlogRow'
import fifthBlogRow from '@/components/blog/fifthBlogRow'
import { getPage, getPostsByCategorySlug } from '@/services/Wordpress/Get'
import { mapGetters } from 'vuex'

export default {
  metaInfo: {
    title: 'Bekijk ons blogs | Tikkl | Een grafisch bureau dat kietelt',
    meta: [
      { charset: 'utf-8' },
      {
        name: 'keywords',
        content: 'TIKKL, Uden'
      },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      {
        hid: 'description',
        name: 'description',
        content: 'Wij zijn trots op onze doordachte huisstijlen en verrassende concepten - Tikkl - een grafisch bureau dat kietelt met doordachte huisstijlen en verrassende concepten'
      },
      {
        property: 'og:title',
        content: 'Bekijk ons blogs | Tikkl | Een grafisch bureau dat kietelt'
      },
      {
        property: 'og:description',
        content: 'Wij zijn trots op onze doordachte huisstijlen en verrassende concepten - Tikkl - een grafisch bureau dat kietelt met doordachte huisstijlen en verrassende concepten'
      },
      { property: 'og:url', content: 'https://tikkl.nl/de-blog' }
    ],
    link: [
      {
        rel: 'icon',
        type: 'image/x-icon',
        href: '/favicon.ico'
      }
    ],
    htmlAttrs: {
      lang: 'nl',
      amp: true
    }
  },
  data() {
    return {
      blogRows: [],
      blogPosts: [],
      pageData: {
        title: '',
        default_content: '',
        custom_content: {},
        seo: {}
      }
    }
  },
  components: {
    firstBlogRow,
    secondBlogRow,
    thirdBlogRow,
    fourthBlogRow,
    fifthBlogRow
  },
  computed: mapGetters(['globalValues']),
  async created () {
    [this.pageData, this.blogPosts] = await Promise.all([
      getPage({ slug: this.$route.path }),
      getPostsByCategorySlug({ name: 'blog' })
    ])

    this.calculateRows()
  },
  methods: {
    calculateRows() {
      let amountAllowedInRow = [4, 3, 3, 4, 3]
      let whichRow = 0
      let amountInRow = 0
      let createNewRow = true
      let rowCounter = 0

      for (let i = 0; i < this.blogPosts.length; i++) {
        if (createNewRow) {
          this.blogRows.push({
            number: (whichRow + 1), data: []
          })
          createNewRow = false
        }

        this.blogRows[rowCounter].data.push(this.blogPosts[i])
        amountInRow++

        if (amountInRow === amountAllowedInRow[whichRow]) {
          createNewRow = true
          amountInRow = 0
          whichRow++
          rowCounter++

          if (whichRow === 5) {
            whichRow = 0
          }
        }
      }
    }
  }
}
</script>